import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function ForWhoSection() {
  const items = ['Para quienes sienten que su mente es un lugar caótico y buscan orden mental.', 'Para quienes quieren aprender a manifestar con resultados reales, no solo con deseos vagos.', 'Para buscadores espirituales que resuenan con las enseñanzas de Neville Goddard y la Ley de Asunción.', 'Para ti, que quieres que Tu Aura Simple sea más que un nombre, que sea tu estado de vida.'];
  return <div className="bg-beige py-20" data-id="element-54">
      <Section data-id="element-55">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-sage/10" data-id="element-56">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy text-center mb-12" data-id="element-57">
            ¿PARA QUIÉN ES ESTE EBOOK?
          </h2>

          <div className="space-y-6" data-id="element-58">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="flex items-start gap-4 group" data-id="element-59">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-sage/20 flex items-center justify-center mt-1 group-hover:bg-sage transition-colors duration-300" data-id="element-60">
                  <Check className="w-5 h-5 text-sage-dark group-hover:text-white transition-colors duration-300" data-id="element-61" />
                </div>
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-62">{item}</p>
              </motion.div>)}
          </div>
        </div>
      </Section>
    </div>;
}